
import { Card, Divider, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, FieldArray, reduxForm } from 'redux-form';
import { PERMISSION_ENTITIES, PERMISSIONS, RED } from '../../_config/consts.js';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import * as ModalActions from '../../redux/actions/modal.actions';
import MDButton from '../MDButton/MDButton.jsx';
import Permission from '../Permission/Permission.jsx';
import MDRadioButtonView from './Elements/MDRadioButtonsGroup/MDRadioButtonView.js';
import CustomField from './Fields/CustomField.jsx';
import MDCheckBoxField from './Fields/MDCheckBox/MDCheckBoxField.js';
import MDCheckBoxGroupField from './Fields/MDCheckBox/MDCheckBoxGroupField.js';
import AdditionalTimeRangeForm from './TimeProfiles/AdditionalTimeRangeForm.jsx';
import MDSwitchField from './Fields/MDSwitch/MDSwitchField.jsx';



const timeOptions = [
  {
    value: 1,
    label: <Entity entity="twentifourhours" />,
  },
  {
    value: 2,
    label: <Entity entity="moringTime" />,
  },
  {
    value: 3,
    label: <Entity entity="afternoonTime" />,
  },
  {
    value: 4,
    label: <Entity entity="moringAndAfternoon" />,
  },
];

const styles = theme => ({
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    width: 'max-content',
  },
});

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  } else if (values.isValidityVisible && (!values.timeProfileTimeFrame.startDate || !values.timeProfileTimeFrame.endDate)) {
    errors.timeProfileTimeFrame = 'required';
  }
  return errors;
};

const onRenderTimeRange = (props) => {
  const { fields, areDeviceDatesLocked, formName, canEdit, formData, timeRangesFieldName, is12HoursFormat, onInitializeNewTimeRange } = props;
  const numberOfTimeRanges = _.size(fields);
  return (
    <div>
      {fields && fields.map((timeRange, index) => (
        <div key={`timeRange${index + 1}`} elevation={2} style={{ marginTop: 20}}>
          <Divider />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, paddingRight: 10 }}>
            <h4 style={{ fontWeight: 'bold', margin: 10 }}><Entity key={index+1} entity="additionalTimeRange" /></h4>
            {index > 0 ? (
              <IconButton
                style={{ marginLeft: 10, marginBottom: 5 }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!formData.isEditing) {
                    fields.remove(index);
                  }
                }}
              >
                <DeleteIcon style={{ color: RED, fontSize: 20 }} />
              </IconButton>
            ) : null}
          </div>
          <AdditionalTimeRangeForm
            formName={formName}
            timeRange={timeRange}
            companyConfigurations={props.companyConfigurations}
            timeRangeIndex={index}
            timeRangesFieldName={timeRangesFieldName}
            areDeviceDatesLocked={areDeviceDatesLocked}
            canEdit={canEdit}
            is12HoursFormat={is12HoursFormat}
          />
        </div>
      ))}
      {numberOfTimeRanges < 6 ? (
        <Card
          style={{ height: 60, marginBottom: 20, marginTop: 20, padding: 20, display: 'flex', flexDirection: 'row', alignItems: 'center' }}
          className="card card-rounded"
          onClick={() => {
            fields.push({});
            onInitializeNewTimeRange(numberOfTimeRanges);
          }}
        >
          <AddCircleOutlineOutlined style={{ color: '#4DB6AC', marginRight: 15, fontSize: 25 }} />
          <h4 style={{ fontWeight: 'bold' }}><Entity entity="newTimeRange" /></h4>
        </Card>
      ) : null}
    </div>
  );
}

@reduxForm({ form: 'CompanyTimeProfileForm', validate })
@connect(state => ({ form: state.form.CompanyTimeProfileForm }))
class CompanyTimeProfileForm extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  
  onDeleteTimeProfileClick() {
    const { dispatch, onDeleteTimeProfileRequest, form } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deleteTimeProfileConfirmation" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => onDeleteTimeProfileRequest(form.values.id),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  onDateCheckboxChange(value) {
    const { dispatch } = this.props;
    this.setState({ timeOptionSelected: value });
    switch (value) {
      case 1: {
        dispatch(change("CompanyTimeProfileForm", "timeIntervalFrom", moment().startOf('day').valueOf()));
        dispatch(change("CompanyTimeProfileForm", "timeIntervalTo", moment().endOf('day').valueOf()));
        break;
      }
      case 2: {
        dispatch(change("CompanyTimeProfileForm", "timeIntervalFrom", moment().startOf('day').set('hours', 9).valueOf()));
        dispatch(change("CompanyTimeProfileForm", "timeIntervalTo", moment().startOf('day').set('hours', 13).valueOf()));
        break;
      }
      case 3: {
        dispatch(change("CompanyTimeProfileForm", "timeIntervalFrom", moment().startOf('day').set('hours', 14).valueOf()));
        dispatch(change("CompanyTimeProfileForm", "timeIntervalTo", moment().startOf('day').set('hours', 18).valueOf()));
        break;
      }
      case 4: {
        dispatch(change("CompanyTimeProfileForm", "timeIntervalFrom", moment().startOf('day').set('hours', 9).valueOf()));
        dispatch(change("CompanyTimeProfileForm", "timeIntervalTo", moment().startOf('day').set('hours', 18).valueOf()));
        break;
      }
      default: {
        dispatch(change("CompanyTimeProfileForm", "timeIntervalFrom", moment().startOf('day').valueOf()));
        dispatch(change("CompanyTimeProfileForm", "timeIntervalTo", moment().endOf('day').valueOf()));
        break;
      }
    }
  }


  onToggleValidityVisibility(value) {
    const { dispatch } = this.props;
    dispatch(change("CompanyTimeProfileForm", "timeProfileTimeFrame", value ? moment().startOf('day').valueOf() : moment().endOf('day').valueOf()));
    dispatch(change("CompanyTimeProfileForm", "isValidityVisible", value));
  }

  render() {
    const { onValidateForm, form, formData, onInitializeNewTimeRange, companyConfigurations, is12HoursFormat, classes } = this.props;

    return (
      <Form style={{ paddingLeft: 15, paddingRight: 15, marginTop: 20 }}>
        <input style={{ display: 'none' }} type="number" name="id" />
        <Entity
          componentClass={Field}
          name="name"
          componentAttribute="placeholder"
          entity="insertTimeProfileName"
          title={<Entity entity="timeProfileName" />}
          component={CustomField}
          type="text"
          mandatory
        />
        <Field
          name="isValidityVisible"
          label={<h4 style={{ fontSize: 15 }}><Entity entity="timeProfileEnableValidity" /></h4>}
          component={MDSwitchField}
          containerstyle={{ paddingLeft: 0, marginTop: 10 }}
          horizontal
          onHandleChange={(value) => this.onToggleValidityVisibility(value)}
          disabled={false}
        />
        {form?.values?.isValidityVisible ? (
          <Entity
            componentClass={Field}
            title={<Entity entity="timeProfileTimeFrame" />}
            name="timeProfileTimeFrame"
            component={CustomField}
            type="airbnbDateRange"
            disabled={false}
            minimumNights={0}
          />
          )
        : null}
        <FieldArray
          name="timeRanges"
          timeRangesFieldName="timeRanges"
          component={onRenderTimeRange}
          formData={formData}
          form={form}
          canEdit
          formName="CompanyTimeProfileForm"
          companyConfigurations={companyConfigurations}
          is12HoursFormat={is12HoursFormat}
          onInitializeNewTimeRange={programId => onInitializeNewTimeRange(programId, 'timeRanges')}
        />
        <div style={{ position: 'absolute', bottom: 0, right: 0, left: 0, backgroundColor: 'white', borderTop: '1px solid #bdbdbd' }}>
          {form?.values?.id? (
            <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <MDButton
                backgroundColor={RED}
                title={<Entity entity="deleteTimeProfile" />}
                onClick={() => this.onDeleteTimeProfileClick()}
              />
            </Permission>
          ) : null}
          <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MDButton
              title={<Entity entity="save" />}
              onClick={() => onValidateForm()}
            />
          </Permission>
        </div>
      </Form>
    );
  }
} 

export default withStyles(styles)(CompanyTimeProfileForm);